import React, { useState } from "react";
import "../../styles/Services.css";
import { FaMinus, FaPlus } from "react-icons/fa";
import { RiArrowRightSLine } from "react-icons/ri";
import Application_bg_img from "../../bg_images/S_app_bg_img.png";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";



const Servicesfaqs = [
  {
    question: "What are product development companies?",
    answer:
      " Product development companies help businesses design, build, and launch new products. They often provide services such as ideation, prototyping, and testing. ",
  },
  {
    question: "What is a product development business?",
    answer:
      " A product development business focuses on turning ideas into tangible products by combining design, engineering, and manufacturing expertise. ",
  },
  {
    question: " What does a product company do? ",
    answer:
      " A product company develops, markets, and sells products. This includes ideating, designing, and manufacturing offerings for customers. ",
  },
];

const ProductDevelopment = () => {
  const navigate = useNavigate();

  const [ServicesopenIndex, ServicessetOpenIndex] = useState(null); // Removed `number | null`

  const handleToggle = (index) => {
    ServicessetOpenIndex(ServicesopenIndex === index ? null : index);
  };

  return (
    <div className="Service_Container">
      {/* Cousals end */}

      <div
        className="Service_sec1"
        style={{
          backgroundImage: `url(${Application_bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "98.5vw",
        }}
      >
        <section className="Service_sec1_one">
          <h5>
            Services{" "}
            <span>
              <RiArrowRightSLine className="servrighticon" />
            </span>
            Product Development
          </h5>
          <h2>
            Bring Your Ideas to Life with Expert Product Development Services
          </h2>
          <p>
            Our product development services focus on creating practical,
            scalable solutions that address real-world needs.
          </p>
          <button onClick={() => navigate("/contact")} className="S_sec1_btn1">
            Talk to an Expert
            <HiArrowNarrowRight className="psec1arrow" />
            {/* <MdArrowRightAlt className="psec1arrow" /> */}
          </button>
        </section>
      </div>

      {/* Sec 2  */}

      <div className="Service_sec2">
        <section className="Service_sec2_in1">
          <h2>What We Offer as a Product Development Company</h2>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img1.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Founders program:
                </span>{" "}
                At Arshil, we have the founders program that enables business
                entrepreneurs to build their MVP in the shortest possible time
                and with minimal resources. This is made possible by our
                state-of-the-art code accelerator, Akscel.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img2.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  End-to-End Product Development Services:
                </span>{" "}
                From ideation to launch, our product development agency ensures
                your product is built with precision. We work closely with your
                team to design, develop, and deploy products that resonate with
                your audience.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img3.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  New Product Development Team:
                </span>{" "}
                Our experienced team includes product designers, engineers, and
                developers who collaborate with you to deliver innovative
                products.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2-img4.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Custom Solutions for Every Industry:
                </span>{" "}
                We work with businesses across industries, including software,
                food, and technology, making us a versatile product development
                studio.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img5.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Support for Startups and Enterprises:
                </span>{" "}
                We guide startups and SMEs in creating their first product and
                assist established enterprises in scaling their offerings.
              </h4>
            </section>
          </section>

          <section>
            <button
              onClick={() => navigate("/contact")}
              className="Service_sec2_in1_button"
            >
              Talk to an Expert
              <HiArrowNarrowRight className="psec1arrow" />
              {/* <MdArrowRightAlt className="psec1arrow" /> */}
            </button>
          </section>
        </section>

        <section>
          <img
            className="s_sec2_img1"
            src="../images/S_productDev_img.png"
            alt=""
          />
        </section>
      </div>

      {/* Sec 3 */}
      <div className="Service_sec3">
        <section className="Service_sec3_one">
          <h2> Why Choose Arshil as Your Product Development Partner? </h2>
          <p>
            Choosing the right product development agency can make all the
            difference in turning ideas into successful products. At Arshil, we
            prioritize delivering value at every step. Here's why businesses
            trust us:
          </p>
        </section>

        <section className="Service_sec3_two">
          <section className="Service_sec3_two_in1">
            <img src="../images/s_pd_sec3_img1.png" alt="" />
            <h5>Dedicated Expertise</h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_pd_sec3_img2.png" alt="" />
            <h5>Collaboration </h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_pd_sec3_img3.png" alt="" />
            <h5>Quality Assurance</h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_pd_sec3_img4.png" alt="" />

            <h5> Scalability </h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_pd_sec3_img3.png" alt="" />
            <h5> Client-Centric Approach </h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/pd_sec3_img6.png" alt="" />
            <h5> Reduced Time-to-Market </h5>
          </section>
        </section>
      </div>

      {/* sec 4  */}

      <div className="Service_sec4">
        <h1> Our Approach to Product Development </h1>
        <p>
          At Arshil, our structured approach to product development ensures your
          ideas transform into impactful solutions. Here's how we do it:
        </p>

        <ul className="Service_sec4_ul">
          <li> Research and Ideation </li>
          <li> Prototyping and Design </li>
          <li> Development and Testing </li>
          <li>Launch and Support</li>
        </ul>
      </div>

      {/* Sec 5 */}

      <section className="Service_sec5_in1_FaQ">
        <h1 className="Service_sec5_in1_FaQ_h1">
          Frequently Asked Questions (FAQs)
        </h1>
        {Servicesfaqs.map((faq, index) => (
          <div key={index} className="Service_sec5_in1_FaQ-in1">
            <div className="faq-header" onClick={() => handleToggle(index)}>
              <h5>{faq.question}</h5>
              <span className="icon">
                {ServicesopenIndex === index ? <FaMinus /> : <FaPlus />}
              </span>
            </div>
            {ServicesopenIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </section>

      <div className="Sec8_container">
        <section>
          <h1> Have a Product Idea but Not Sure Where to Begin? </h1>
          <p>
            Ready to turn your idea into reality? Connect with Arshil, a leading
            product development company, and get expert guidance on bringing
            your vision to life.
          </p>
        </section>

        <section className="Sec8_container_button">
          <button onClick={() => navigate("/contact")}>
            Start Your Project Today
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default ProductDevelopment;



